import { Box, Divider, Grid2, Typography } from '@mui/material'
import React from 'react'
import { CustomBadge } from '../../utils/Badge'
import { AvatarCollabs } from '../../utils/AvatarCollabs'
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { useTrainerCourseCount } from '../../../assets/api/useTrainerGetApi';

const ReportCom = () => {
    const { data: trainerCourseCount, isLoading } = useTrainerCourseCount()
    console.log("trainerCourseCount", trainerCourseCount)
    return (
        <Grid2 container>
            {
                trainerCourseCount?.data?.map((item, index) => (
                    <>
                        <Grid2 key={index} children size={{ xs: 12, sm: 5.9 }} pl={{ xs: 0, sm: index == 1 ? 3 : 0 }}>
                            <Box sx={{ display: "flex", gap: 4, mb: 3, justifyContent: "space-around" }}>
                                <Typography variant='h5'>Active Student</Typography>
                                <CustomBadge icon={<PeopleOutlineIcon />} />
                            </Box>
                            <Box sx={{ display: "flex", gap: 5, alignItems: "start", justifyContent: "space-around" }}>
                                <Box>
                                    <Typography variant='h6' color='blue.main'>{item?.title}</Typography>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Typography variant='h2'>{item?.total_students}</Typography>
                                        <AvatarCollabs />
                                    </Box>
                                </Box>
                                <CustomBadge bgcolor={"#E2FFDD"} icon={<TrendingUpIcon sx={{ color: "#00BF59" }} />} />
                            </Box>
                        </Grid2>

                        {/* {index == 0 && <Divider
                            orientation="horizontal"
                            flexItem
                            sx={{ border: "1px solid #B3C6FF" }}
                        />} */}

                    </>

                ))
            }
        </Grid2>
    )
}

export default ReportCom